// one minute
export const ONE_MINUTE = 60 * 1e3

// one week
export const ONE_WEEK = 7 * 24 * 60 * 60 * 1e3

// tokens
export const TOKENS = 'TOKENS'

export const THIRD_ACCESS_TOKEN = 'THIRD_ACCESS_TOKEN'

export const THIRD_REFRESH_TOKEN = 'THIRD_REFRESH_TOKEN'

export const EDMODO_USER_INFO = 'EDMODO_USER_INFO'

export const LOGIN_USER_INFO_KEY = 'LOGIN_USER_INFO_KEY'

export const LOGIN_USER_INVITE_CODE_KEY = 'LOGIN_USER_INVITE_CODE_KEY'

export const AUTH = 'AUTH-AUTH'

export const LANGUAGE = 'LANGUAGE'

export const LANGUAGE_LIST = 'LANGUAGE_LIST'

export const EDMODO_USER = 'EDMODO_USER'

export const SEARCH_KEY = 'SEARCH_KEY'

// export const EDMODO_TITLE = 'Edmodo ClassFlow Help Center'
export const OSTYPEARR = [
  { value: 1, label: 'Android' },
  { value: 2, label: 'iOS' },
  { value: 3, label: 'Windows Phone' },
  { value: 4, label: 'Windows' },
  { value: 5, label: 'MAC' },
  { value: 6, label: 'PC' },
  { value: 7, label: 'WEB' },
  { value: 8, label: 'iPad' },
  { value: 9, label: 'Android Pad' }
]



// WEBPACK FOOTER //
// ./src/utils/constants.js